import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Fade from "@mui/material/Fade";
import { fontRoboto, transientOptions } from "@product/scmp-sdk";

import { BaseEntityLink } from "~/components/base-entity-link";
import { Popper } from "~/components/common/popper";
import { ZIndexLayer } from "~/lib/styles";

import { HeaderAllMenuApplications } from "./header-all-menu-applications";
import { HeaderAllMenuColumnists } from "./header-all-menu-columnists";
import { HeaderAllMenuEpaper } from "./header-all-menu-epaper";
import { HeaderAllMenuFocus } from "./header-all-menu-focus";
import { HeaderAllMenuHighlights } from "./header-all-menu-highlights";
import { HeaderAllMenuSection } from "./header-all-menu-section";
import { HeaderAllMenuTopics } from "./header-all-menu-topics";
import ArrowIcon from "./icon-arrow.svg";

export const StyledBaseEntityLink = styled(BaseEntityLink)``;

type ToggleProps = {
  $isToggle: boolean;
};

export const Title = styled.span`
  display: flex;
  flex-flow: row nowrap;
  gap: 4px;
  align-items: center;

  block-size: 16px;

  color: #4585ff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 120%;
`;

export const StyledIconArrow = styled(ArrowIcon, { ...transientOptions })<ToggleProps>`
  transform: rotate(0deg);

  transition: transform 0.2s;
  ${props => {
    if (!props.$isToggle) return;
    return css`
      transform: rotate(180deg);
    `;
  }}
`;

export const ToggleContainer = styled.div<ToggleProps>`
  display: flex;
  align-items: center;

  padding: 4px;

  background: ${props => (props.$isToggle ? "rgba(69, 133, 255, 0.2)" : "unset")};

  cursor: pointer;
`;

export const StyledPopper = styled(Popper)`
  inset-inline-start: 50% !important;
  z-index: ${ZIndexLayer.AppBar};

  inline-size: 100vw !important;
  margin-inline-start: -50vw !important;

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inset-inline-start: 50% !important;

    inline-size: 1440px !important;
    margin-inline-start: -720px !important;
  }
`;

export const MegaMenuWrapper = styled.div`
  margin-block-start: 18px;
  padding-block: 32px 40px;

  background-color: #e5e5e5;

  border-block-end: 1px solid #000000;
`;

export const MegaMenuContainer = styled.div`
  display: grid;
  grid:
    "section topics-and-focus application columnists" min-content
    "highlight highlight highlight highlight" min-content
    / auto fit-content(12%) max-content max-content;
  gap: 20px 32px;

  inline-size: 100%;
  max-inline-size: 1272px;
  margin-inline: auto;
  padding-inline: 32px;

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    grid:
      "section topics-and-focus application columnists" min-content
      "highlight highlight highlight highlight" min-content
      / auto fit-content(15%) max-content max-content;
  }
`;

export const StyledHeaderAllMenuApplications = styled(HeaderAllMenuApplications)`
  grid-area: application;
`;
export const StyledHeaderAllMenuColumnists = styled(HeaderAllMenuColumnists)`
  grid-area: columnists;
`;
export const StyledHeaderAllMenuFocus = styled(HeaderAllMenuFocus)`
  grid-area: focus;
`;
export const StyledHeaderAllMenuEpaper = styled(HeaderAllMenuEpaper)`
  grid-area: epaper;
`;
export const StyledHeaderAllMenuSection = styled(HeaderAllMenuSection)`
  grid-area: section;
`;
export const StyledHeaderAllMenuTopics = styled(HeaderAllMenuTopics)`
  grid-area: topics;
`;

export const HeaderAllMenuTopicsAndFocus = styled.div`
  grid-area: topics-and-focus;

  display: grid;
  grid:
    "topics" min-content
    "focus" min-content
    "epaper" min-content
    / fit-content(100%);
  row-gap: 28px;
`;

export const StyledHeaderAllMenuHighlight = styled(HeaderAllMenuHighlights)`
  grid-area: highlight;
`;

export const StyledFade = styled(Fade)`
  max-inline-size: 1616px;
  margin-inline: auto;
`;
